// test1678
(1678 && 0);
